import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-mu-alert',
  templateUrl: './mu-alert.component.html',
  styleUrls: ['./mu-alert.component.sass'],
})
export class MuAlertComponent implements OnInit {
  @Input() styles: string;
  @Input() message: string;
  @Input() showAlert: boolean;

  constructor() {
    /** */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  /**
   * method for show or not alert
   * return {void}
   */
  closeAlert(): void {
    this.showAlert = !this.showAlert;
  }
}
